export default "__VITE_ASSET__0ba6ba2b__"